import React, { Component } from 'react'
import PropTypes from 'prop-types'

class SimpleTitle extends Component {
  render () {
    const {
      box,
      className
    } = this.props

    return (
      <span className={className}>
        { box.title }
      </span>
    )
  }
}

SimpleTitle.propTypes = {
  box: PropTypes.object.isRequired
}

export default SimpleTitle
